// TORQ brand — dark/light mode toggle.
// The initial (no-flash) theme is set by an inline blocking script in
// theme.liquid's <head>, before CSS paints. This file only wires up the
// click handler and persists the choice.
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var btn = document.getElementById('torqThemeToggle');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var isDark = document.documentElement.getAttribute('data-theme') === 'dark';
      var next = isDark ? 'light' : 'dark';

      if (next === 'dark') {
        document.documentElement.setAttribute('data-theme', 'dark');
      } else {
        document.documentElement.removeAttribute('data-theme');
      }

      try {
        localStorage.setItem('torq_theme', next);
      } catch (e) {}
    });
  });
})();
